import { useEffect, useMemo, useState } from "react";

import { Box, Button, Card, Checkbox, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import Image from "Assets/Images/Login/image.png";
import { starDashboardZoneLinkCreater, starDashboardStationLinkCreater, starDashboardPathLinkCreater } from "Helper/sidebar";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { OperationNames } from "Types/operation";

import useCancelOperation from "Hooks/useCancelOperation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";

import { deselectPath, toggleFullScreen } from "Redux/servicesSlice";
import { setMinimize } from "Redux/mapSlice";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import usePaths from "Hooks/usePaths";
import useEditPath from "Hooks/useEditPath";

// const starBaseUrl = process.env.REACT_STAR_BASE_URL;

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function SimpleDashboard() {
  const dispatch = useAppDispatch();
  const [starLink1, setStarLink1] = useState<string>();
  const [starLink2, setStarLink2] = useState<string>();
  const [openStar, setOpenStar] = useState<boolean>();
  const [openStar2, setOpenStar2] = useState<boolean>();
  const { path } = useAppSelector((state) => state.app);
  const { starMiniDashUrl, starFullDashUrl } = useAppSelector((state) => state.side);
  const { fullScreen } = useAppSelector((state) => state.services);
  const { visible: cameraVisible } = useAppSelector((state) => state.camera);
  const { visible: eventVisible } = useAppSelector((state) => state.event);
  const { visible: marginParkVisible } = useAppSelector((state) => state.marginPark);
  const { visible: passageVisible } = useAppSelector((state) => state.passage);
  const { visible: trafficPathVisible } = useAppSelector((state) => state.trafficPath);
  const { visible: trafficFleetVisible } = useAppSelector((state) => state.trafficFleet);
  const { trafficAnalysisStarUrl } = useAppSelector((state) => state.star);

  const data = usePaths();

  const { height } = useWindowSize();

  const { cancelOperation } = useCancelOperation();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const operationNames: OperationNames[] = ["create-path", "edit-path"];

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const handleScreenSize = () => {
    dispatch(toggleFullScreen());
  };

  const makeFullScreenSize = () => {
    if (!fullScreen) {
      dispatch(toggleFullScreen());
    }
  };

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2) + 12}px`;
  }, [height]);

  return (
    <Fade
      in={cameraVisible || passageVisible || marginParkVisible || trafficPathVisible || eventVisible || trafficFleetVisible}
      mountOnEnter
      unmountOnExit
    >
      <Card sx={{ mt: 1, p: fullScreen ? "2vw" : "1vw", width: "100%", boxShadow: 3, paddingTop: "8px" }}>
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Button sx={{ width: "30px", minWidth: "0" }} onClick={handleScreenSize}>
            {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </Button>
          {!fullScreen ? (
            <Button
              startIcon={
                <KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />
              }
              sx={{ minWidth: "100px" }}
              onClick={toggleCollapse}
            >
              {isOpen ? "بستن" : "بازکردن"}
            </Button>
          ) : null}
        </Stack>

        <Collapse in={isOpen}>
          <iframe
            src={fullScreen ? trafficAnalysisStarUrl[0] : trafficAnalysisStarUrl[1]}
            title="star-dashboard"
            style={{
              width: fullScreen ? "94vw" : "100%",
              height: fullScreen ? "85vh" : boxHeight,
              transition: "all 0.3s",
              border: "none",
            }}
            onError={() => {}}
          />
          <Stack>
            {!fullScreen ? (
              <Button
                variant="contained"
                sx={{ textAlign: "center", margin: "auto", justifyContent: "center" }}
                onClick={makeFullScreenSize}
              >
                مشاهده جزییات
              </Button>
            ) : null}
          </Stack>
        </Collapse>
      </Card>
    </Fade>
  );
}
